module.exports = __webpack_public_path__ + "static/img/20d753ff3d1e405a7ee04a1284e49e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv4.png
// module id = TfkQ
// module chunks = 1